import React from "react";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography,
  withStyles
} from "@material-ui/core";
import { DocumentUploaderDialog } from "@containers/DocumentUploader/DocumentUploaderDialog";
import locale from "@bonliva-crm/locale";
import { Classes } from "@theme";

type Props = {
  classes: Classes<typeof styles>;
  documentTypes: LabelValue[];
  initialDocumentType?: string;
  files: File[];
  onClose?: () => void;
  onUpload: (documentType: string) => Promise<any>;
};

type State = {
  documentType: string;
};

class DocumentUploaderBase extends React.Component<Props, State> {
  static getDerivedStateFromProps(props: Props, state: State): State {
    if (props.files.length === 0) {
      return {
        documentType: ""
      };
    }

    if (!state || !state.documentType) {
      return {
        documentType: props.initialDocumentType || ""
      };
    }

    return state;
  }
  state: State = { documentType: "" };

  setDocumentType = (v) => this.setState({ documentType: v });

  render() {
    const { classes, files = [] } = this.props;
    const { documentType } = this.state;

    return (
      <DocumentUploaderDialog
        canSubmit={Boolean(documentType)}
        files={files}
        onClose={this.props.onClose}
        onUpload={() => this.props.onUpload(this.state.documentType)}
        renderInitial={(docList) => {
          const { documentTypes } = this.props;

          if (documentTypes.length > 1) {
            return (
              <div className={classes.list}>
                <FormControl className={classes.documentType}>
                  <Select
                    autoWidth
                    displayEmpty
                    onChange={(e) => this.setDocumentType(e.target.value)}
                    value={documentType}
                    data-test="DocumentTypeSelect"
                  >
                    <MenuItem value="" disabled>
                      {locale["Document type"].toLocaleLowerCase()}
                    </MenuItem>

                    {this.props.documentTypes.map(({ label, value }) => (
                      <MenuItem value={value} key={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>

                  <FormHelperText>
                    {locale["Document type"].toLocaleLowerCase()}
                  </FormHelperText>
                </FormControl>

                {docList}
              </div>
            );
          }

          if (documentTypes.length === 1) {
            return (
              <div className={classes.list}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                  {documentTypes[0]?.label ?? ""}
                </Typography>
                {docList}
              </div>
            );
          }

          return null;
        }}
      />
    );
  }
}

const styles = () => ({
  list: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },

  documentType: {
    width: 200
  }
});

export const DocumentUploader = withStyles(styles as any)(DocumentUploaderBase);
